const Unauthorized = () => {
    return <div>You are not authorized to access this page.</div>;
  };
  
  export default Unauthorized;